import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


const HeaderLabel = styled.h2`
  font-size: 14px;
  color: #444;
  padding-bottom: 3px;
  padding-left: 5px;
  border-bottom: 1px solid #d9d9d9;
`;

const GroupTable = styled.table`
  width: 100%;
  margin-top: 0;
  padding-top: 0;
  margin-bottom: 1em;
  border-collapse: separate;
  text-align: left;
  border-top: 0;
`;

const GroupTableCaption = styled.caption`
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  font-size: 0.92em;
  padding: 5px 7px;
  color: #999;
`;

const GroupTableTH = styled.th`
  width: 40%;
  font-weight: bold;
  padding: 5px 7px;
  vertical-align: top;
  text-align: left;
  border-top: 1px solid #ccc;
`;

const GroupTableTD = styled.td`
  width: 60%;
  padding: 5px 7px;
  vertical-align: top;
  text-align: left;
  border-top: 1px solid #ccc;
`;

const ProductPageSpecificationTabContent = ({ headerLabel, tablesData }) => (
  <>
    <HeaderLabel
      dangerouslySetInnerHTML={{ __html: headerLabel }}
    />
    {tablesData.map((tableData, i) => (
      <GroupTable key={tableData.groupLabel + i}>
        <GroupTableCaption>{tableData.groupLabel}</GroupTableCaption>
        {tableData.specifications.map((specification, j) => (
          <tbody key={specification.label + j}>
            <tr>
              <GroupTableTH>{specification.label}</GroupTableTH>
              <GroupTableTD
                dangerouslySetInnerHTML={{ __html: specification.value.replace(/\n/g, '<br>') }}
              />
            </tr>
          </tbody>
        ))}
      </GroupTable>
    ))}
  </>
);

ProductPageSpecificationTabContent.propTypes = {
  headerLabel: PropTypes.string.isRequired,
  tablesData: PropTypes.arrayOf(
    PropTypes.shape({
      groupLabel: PropTypes.string.isRequired,
      specifications: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired
        }).isRequired
      ).isRequired
    }).isRequired
  ).isRequired
};

export default ProductPageSpecificationTabContent;
